import SolidityContract from '@exodus/solidity-contract'

import ABI from '../abi/index.js'

export default function createContract(address, contractName) {
  // keep switch logic in anticipation of support for ERC721
  switch (contractName) {
    // case 'dai':
    //   return new SolidityContract(ABI.dai, address)
    // case 'cdai':
    //   return new SolidityContract(ABI.cdai, address)
    case 'augurv2':
      return new SolidityContract(ABI.repv2, address, true)
    case 'aragon':
      return new SolidityContract(ABI.ant, address, true)
    case 'golem':
      return new SolidityContract(ABI.gnt, address, true)
    case 'loomv2Swap':
      return new SolidityContract(ABI.loomv2Swap, address, true)
    case 'kyberv2':
      return new SolidityContract(ABI.kyberv2, address, true)
    case 'maticValidatorShare':
      return new SolidityContract(ABI.maticValidatorShare, address, true)
    case 'maticStakingManager':
      return new SolidityContract(ABI.maticStakingManager, address, true)
    case 'polygon':
      return new SolidityContract(ABI.matic, address, true)
    case 'ethStakingAccounting':
      return new SolidityContract(ABI.ethStakingAccounting, address, true)
    case 'ethStakingPool':
      return new SolidityContract(ABI.ethStakingPool, address, true)
    case 'fantomSfc':
      return new SolidityContract(ABI.fantomSfc, address, true)
    case 'ensResolver':
      return new SolidityContract(ABI.ensResolver, address, true)
    case 'ensRegistry':
      return new SolidityContract(ABI.ensRegistry, address, true)
    case 'erc721':
      return new SolidityContract(ABI.erc721, address, true)
    case 'optimismGasOracle':
      return new SolidityContract(ABI.optimismGasOracle, address, true)
    default:
      return SolidityContract.erc20(address)
  }
}
